module.exports = __webpack_public_path__ + "img/cl.4de60078.svg";